import { Grid2 } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/logos/admin_logo.svg";
import "../DrugAssignment.css";

const DrugConfirmation = ({ setShowConfirm, data }) => {
  const navigate = useNavigate();

  const fields = [
    { label: "Drug Type", key: "drugName" },
    { label: "Sequence Range", key: "seqRange" },
    { label: "Kit Count", key: "kitCount" },
    { label: "Lot", key: "lot" },
    { label: "Label Group", key: "labelGrp" },
    { label: "Depot", key: "depotName" },
    { label: "Protocol(s)", key: "protocols" },
  ];

  const email = localStorage.getItem("email");

  return (
    <div className="content-body">
      <p className="bread-crumbs-link-container" style={{ fontWeight: "600" }}>
        <Link className="bread-crumbs-link" to="/">
          Home
        </Link>{" "}
        |{" "}
        <Link
          className="bread-crumbs-link"
          to="/drug-assignment-batch-release"
          onClick={() => setShowConfirm(false)}
        >
          Drug Assignment Batch Release
        </Link>
        |{" "}
        <Link className="bread-crumbs-link">
          Drug Assignment Batch Release Confirmation
        </Link>
        -{" "}
        <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
      </p>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={6}>
          <p className="page-heading">
            Genesis StudyPortal Confirmation of Drug Assignment - Batch Release
          </p>
        </Grid2>
      </Grid2>
      <div className="heading-container">
        <h4>
          Confirmation of Drug Assignment - Batch Release Genesis StudyPortal
        </h4>
      </div>
      <div className="inner-heading-container">
        <img className="admin-logo logo-image" src={logo} alt="Genesis Logo" />
        <div className="data-block">
          <div className="data-inner-block">
            <span className="data-inner-block-text">User Name : </span>
            <span style={{ color: "white" }}> {email}</span>
          </div>

          <div className="data-block">
            <span className="data-inner-block-text">
              System Transaction Date :
            </span>
            <span style={{ color: "white" }}>
              {" "}
              {new Date().toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
      <div className="data-content-container">
        {fields.map(({ label, key }) => (
          <div className="data-content" key={key}>
            <span className="data-content-label">{label}:</span>
            <span className="data-content-value">{data?.[key]}</span>
          </div>
        ))}
      </div>

      <div className="note-container">
        <span
          style={{
            fontWeight: "600",
            color: "#585858",
          }}
        >
          Note :
        </span>
        <span>This assignment of drug was recorded successfully.</span>
      </div>
      <div
        style={{
          height: "20px",
        }}
      ></div>
      <div className="footer-container">
        <span>
          Genesis 2025-Please contact Genesis Support for assistance at
          Genesis.com/support
        </span>
      </div>
      <div
        style={{
          textAlign: "left",
          margin: "10px",
          fontSize: "10px",
        }}
      >
        You will receive an email confirmation of this transaction.
      </div>
      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              navigate("/");
            }}
          >
            Home
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default DrugConfirmation;
